import { useQuery } from "@tanstack/react-query";
import { ICapacityLeadBasicInfo } from "./dto";
import { getCapacityLead } from "constants/reactQueryKey";
// Dummy-Daten definieren
const mockCapacityLeadData: ICapacityLeadBasicInfo = {
    secureId: "dummy-123",
    capacityLeadNumber: "CL-456",
    productName: "Dummy Produkt",
    firstName: "Max",
    lastName: "Mustermann",
    clientAvailability: "Sofort verfügbar",
    requestRegion: "Musterland",
    requestZipCode: "12345",
    productCriteriaList: [],
    capacityLeadState: 0,
    productType: 1,
    phoneNumbers: [],
};
// Angepasster Hook, der Dummy-Daten zurückgibt
export const useGetCapacityLeadById = (secureId: string, options = {}) => {
    return useQuery(
        [getCapacityLead, secureId],
        async () => {
            // Simuliere einen API-Call mit einer kurzen Verzögerung
            return new Promise<ICapacityLeadBasicInfo>((resolve) =>
                setTimeout(() => resolve(mockCapacityLeadData), 100)
            );
        },
        {
            ...options,
            // Optional: initialData, falls direkt gerendert werden soll
            initialData: mockCapacityLeadData
        }
    );
};